import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { DATE_RANGE_PRESETS } from '@constants/generic-constants';
import ErrorMessage from '../error-message';
import { Label, Skeleton } from '../index';

const { RangePicker: AntdDatePicker } = DatePicker;
dayjs.extend(weekday);
dayjs.extend(localeData);

const DateRangePicker = ({
  startDate,
  endDate,
  picker = 'day',
  loading = false,
  showRangePreset = false,
  rangePresets = [],
  allowEmpty = [false, false],
  format = 'DD/MM/YY',
  onChange = () => {},
  onClear = () => {},
  filterSelected,
  showTime = false,
  disabled = false,
  placeholder = '',
  label = '',
  labelSize = 'small',
  labelClassName = '',
  required = false,
  errorMsg,
  fullPlaceholder,
  size = 'large',
  disableFutureDates = false,
  disablePastDates = false,
  prefillStartDate = false,
  onClick = () => {},
  panelRender = undefined,
  separator = undefined,
}) => {
  const handleClear = () => {
    onClear && onClear();
  };

  const disabledDate = (current) => {
    return disableFutureDates
      ? current && current > dayjs().endOf('day')
      : disablePastDates
        ? current && current < dayjs().startOf('day')
        : false;
  };

  if (loading) return <Skeleton height={40} />;

  const CUSTOM_PRESETS = DATE_RANGE_PRESETS?.map((preset) => {
    const rangeMatch =
      preset?.value?.[0]?.isSame(dayjs(startDate), 'day') && preset?.value?.[1]?.isSame(dayjs(endDate), 'day');
    return {
      ...preset,
      label: (
        <span
          style={{
            backgroundColor: rangeMatch ? 'var(--ant-color-primary)' : 'transparent',
            color: rangeMatch ? 'white' : 'black',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '6px',
            paddingRight: '20px',
            borderRadius: '4px',
          }}
        >
          {preset?.label}
        </span>
      ),
    };
  });

  return (
    <div>
      {label && (
        <Label size={labelSize} className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      <AntdDatePicker
        placeholder={fullPlaceholder ? fullPlaceholder : [placeholder, '']}
        separator={separator ? separator : startDate && endDate ? '-' : ''}
        presets={showRangePreset ? (rangePresets.length > 0 ? rangePresets : CUSTOM_PRESETS) : []}
        inputReadOnly={true}
        allowClear={onClear}
        showTime={showTime}
        value={
          startDate && endDate
            ? [dayjs(startDate), dayjs(endDate)]
            : startDate && prefillStartDate
              ? [dayjs(startDate)]
              : []
        }
        disabled={disabled}
        picker={picker}
        allowEmpty={allowEmpty}
        format={format}
        style={{
          color: filterSelected,
          fontWeight: filterSelected ? 'bold' : '',
        }}
        size={size}
        onChange={(value, dateStrings) => {
          if (value) {
            const startDateValue = value[0];
            const endDateValue = value[1];
            onChange(startDateValue, endDateValue);
          } else if (!value) {
            handleClear();
          }
        }}
        disabledDate={disabledDate}
        onClick={onClick}
        panelRender={panelRender}
        className={filterSelected ? "selectedFilter" : ""}
      />
      {errorMsg && <ErrorMessage errorMsg={errorMsg} />}
    </div>
  );
};

export default DateRangePicker;
